module.exports = __webpack_public_path__ + "media/application/images/svgs/video-off-b403ce5f73fc91e80dc5dab8cadb7e8b.svg";